export default "__VITE_ASSET__CTscq9Fd__"